import type { FaireProductEntity } from "../../entity_types/product";

export const p_embu9wurwd: FaireProductEntity = {
  token: "p_embu9wurwd",
  type: "product",
  name: "Colorful Enamel Evil Eye Adjustable Multi-Stone Ring",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/91b550c0c9fa7c6ae055b1ff70a0b092fccc7c24c4fed2f604bcb978563007e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10e3aca5a01a54e09a7ed525935e028a114cc6210ce81b0077b0812ca61af407.jpeg",
    "https://cdn.faire.com/fastly/acddf9c3a669f6379cd8f84369e5956b6d85aa7101de6109105cb352ab33967d.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "Creating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive price!\nTake a look at more detail information about this item:\n\nSuch a cute and Bold Link ring! It's a Chunky, everyday ring that is elegant, chic, and trendy. It is perfect for all ages, and as a gift.\nThis listing is for ONE Adjustable ring only.\n\nDescription: \nMaterial: Brass Based with Gold Plated, Cubic Zirconia, Enamel\nSize: 22x21mm\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nIf you any questions regarding our products, bulk discount, and issue please send us a message\n\nThank you for your visit!",
  tags: [],
  msrpDollars: 12.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:55.428Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
